export const API_PATH2 = window.location.origin+"/wp-json/wp/v2/";
//export const API_PATH2 = "https://intranet.wmccann.com/wp-json/wp/v2/";

